import React from "react";
import { Search, Download, X } from "lucide-react";
import { inputCls } from "@/components/shared";

export default function FilterBar({
  search,
  onSearch,
  status,
  onStatus,
  statusOptions,
  dateFrom,
  onDateFrom,
  dateTo,
  onDateTo,
  onExport,
  onClear,
  searchPlaceholder = "Ara…",
  testidPrefix = "filter",
}) {
  const hasFilter = search || status || dateFrom || dateTo;
  return (
    <div className="bg-white border border-[#E6E4DD] rounded-2xl p-4 mb-6 flex flex-wrap items-end gap-3" data-testid={`${testidPrefix}-bar`}>
      <div className="flex-1 min-w-[200px]">
        <label className="text-[10px] tracking-[0.15em] uppercase font-bold text-[#5C5B57] mb-1 block">Arama</label>
        <div className="relative">
          <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5C5B57]" strokeWidth={1.75} />
          <input
            type="text"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            placeholder={searchPlaceholder}
            data-testid={`${testidPrefix}-search`}
            className={`${inputCls} pl-9`}
          />
        </div>
      </div>
      {statusOptions && (
        <div className="min-w-[160px]">
          <label className="text-[10px] tracking-[0.15em] uppercase font-bold text-[#5C5B57] mb-1 block">Durum</label>
          <select value={status} onChange={(e) => onStatus(e.target.value)} data-testid={`${testidPrefix}-status`} className={inputCls}>
            <option value="">Tümü</option>
            {statusOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
          </select>
        </div>
      )}
      <div>
        <label className="text-[10px] tracking-[0.15em] uppercase font-bold text-[#5C5B57] mb-1 block">Başlangıç</label>
        <input type="date" value={dateFrom} onChange={(e) => onDateFrom(e.target.value)} data-testid={`${testidPrefix}-date-from`} className={inputCls} />
      </div>
      <div>
        <label className="text-[10px] tracking-[0.15em] uppercase font-bold text-[#5C5B57] mb-1 block">Bitiş</label>
        <input type="date" value={dateTo} onChange={(e) => onDateTo(e.target.value)} data-testid={`${testidPrefix}-date-to`} className={inputCls} />
      </div>
      {hasFilter && (
        <button onClick={onClear} data-testid={`${testidPrefix}-clear`} className="px-3 py-2.5 text-sm text-[#5C5B57] hover:text-[#2D2C2A] flex items-center gap-1">
          <X size={14} /> Temizle
        </button>
      )}
      {!hasFilter && (
        <button
          disabled
          data-testid={`${testidPrefix}-clear`}
          className="px-3 py-2.5 text-sm text-[#5C5B57]/40 flex items-center gap-1 cursor-not-allowed"
          aria-hidden="true"
          style={{ display: "none" }}
        >
          <X size={14} /> Temizle
        </button>
      )}
      {onExport && (
        <button onClick={onExport} data-testid={`${testidPrefix}-export`} className="ml-auto inline-flex items-center gap-2 border border-[#E6E4DD] rounded-xl px-4 py-2.5 text-sm font-medium text-[#2D2C2A] hover:bg-[#F0EFEA] transition-colors">
          <Download size={16} strokeWidth={1.75} /> CSV
        </button>
      )}
    </div>
  );
}
